module.exports = __webpack_public_path__ + "img/Speaker=Eptehal Nashnoush.8736813a.png";